import { createQueryKeys } from '@lukemorales/query-key-factory';

import { get } from '@/api/api';
import { buildQueryParams } from '@/hooks/api/helpers';
import type {
  FanguardApiContractsInteractionInteractionDetails,
  FanguardApiContractsInteractionInteractionResponseModel,
  FanguardApiContractsInteractionInteractionTypeModelEnum,
} from 'src/api/generated';

export const INTERACTIONS_URI = 'interactions';

export interface InteractionDetailParams {
  type: FanguardApiContractsInteractionInteractionTypeModelEnum;
  venueIds: string;
  searchTerm?: string;
  page?: number;
  pageSize?: number;
  includeCount?: boolean;
}

export const interactionsQueries = createQueryKeys(INTERACTIONS_URI, {
  all: null,
  detail: (interactionId: string, params: InteractionDetailParams) => ({
    queryKey: [interactionId, params],
    queryFn: async () => {
      const response = await get<FanguardApiContractsInteractionInteractionResponseModel>({
        uri: `${INTERACTIONS_URI}/${interactionId}?${buildQueryParams(params as unknown as Record<string, string | number | boolean | null | undefined>)}`,
      });
      return response.data;
    },
  }),
  details: (interactionId: string) => ({
    queryKey: [interactionId, 'details'],
    queryFn: async () => {
      const response = await get<FanguardApiContractsInteractionInteractionDetails>({
        uri: `${INTERACTIONS_URI}/${interactionId}/details`,
      });
      return response.data;
    },
  }),
});
